const styles = theme => ({
  form: {
    display: 'flex',
    margin: theme.spacing(2, 0),
    flexDirection: 'column',
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      '& > * + *': {
        marginLeft: theme.spacing(1),
      },
    },
  },
})

export default styles
